import { render } from "./CoverArtistTopTracks.vue?vue&type=template&id=4cad9442"
import script from "./CoverArtistTopTracks.vue?vue&type=script&lang=js"
export * from "./CoverArtistTopTracks.vue?vue&type=script&lang=js"

import "./CoverArtistTopTracks.vue?vue&type=style&index=0&id=4cad9442&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__